import { render, staticRenderFns } from "./error-block.vue?vue&type=template&id=c0a9e5e8&"
import script from "./error-block.vue?vue&type=script&lang=ts&"
export * from "./error-block.vue?vue&type=script&lang=ts&"
import style0 from "./error-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports